
















import { Component, Model, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class RadioBox extends Vue {
    @Prop() public readonly group!: string;
    @Prop({ default: '' }) public readonly label!: string;
    @Prop({ default: '' }) public readonly value!: string;
    @Prop({ default: '' }) public readonly tooltip!: string;
    @Model('change', { type: String }) public readonly modelValue!: string;

    get shouldBeChecked() {
        return this.modelValue === this.value;
    }

    public updateInput() {
        this.$emit('change', this.value);
    }

}
